module.exports = __webpack_public_path__ + "0af23b17bb64c6abe56d2a463dda6341.svg";